import z from 'zod';

export const OptionSchema = z.object({
  value: z.string(),
  label: z.string(),
});

export type OptionItem = z.infer<typeof OptionSchema>;

export const ApproverEntitySchema = z.object({
  id: z.string(),
  label: z.string(),
  type: z.enum(['user', 'role', 'operation']),
});

export type ApproverEntity = z.infer<typeof ApproverEntitySchema>;
